import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';

export class TableNavigationModel {
    public Keyword: string;
    public Page: PageEvent;
    public Sort: Sort;
}
